<template>
    <div>
      <nav class="navbar navbar-light bg-light fixed-top">
        <!--ヘッダーにmax-width1920がいらない時はここを削除。対応する</div>も一緒に-->
        <div class="m-width1920">
          <div class="d-flex align-items-center">
            <!--ここまで↑-->
            <a class="navbar-brand" href="/">
              <img
                class="navbar-logo"
                src="@/assets/img/logo/treasure_logo.png"
                alt="野球グラブのオーダーメイドシミュレーション | Treasure ロゴ"
              />
            </a>
            <div class="nav-link">
                TOP > お問い合わせ > お問い合わせ内容の確認 > お問い合わせ送信完了
            </div>
          </div>
        </div>
      </nav>
      <!--固定ヘッダー-->
  
      <!-- フォームセクション -->
      <div class="container mt-5">
        <div class="card thanks-body">
          <p class="lead form-text-center thanks-top-text">
            お問い合わせありがとうございました。
          </p>
          <!-- シミュレーションID -->
          <div class="thanks-text-center thanks-text-margin">
            <p class="thanks-text-center">
                ご入力いただいたメールアドレス宛に自動返信メールをお送りしております。
              <br />
              内容を確認後、担当者よりご連絡させていただきます。
              <br />
              ご連絡をお待ちください、
            </p>
          </div>
        </div>
        <!-- ボタン -->
        <div class="form-row">
          <div class="col">
            <a
              href="/"
              class="form-btn-block form-btn-secondary btn btn-block thanks-btn"
              >TOPへ戻る</a
            >
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
  export default {
    name: "ThanksPage",
  };
</script>
  
<style scoped>
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form__btn_gap {
  gap: 5vw;
  padding: 1vw 0 3vw 0;
}
.col {
  padding-right: 5px;
  padding-left: 5px;
}
  
.form-btn-block {
  padding: 10px;
  font-size: 16px;
  border-radius: 25px;
}
.btn-block {
  display: block;
  width: 15%;
}
  
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
  
.form__main {
  max-width: 700px;
}
@media (max-width: 1000px) {
  .btn-block {
    width: 20vw;
  }
}
@media (max-width: 768px) {
  .btn-block {
    width: 35vw;
  }
}
.navbar {
  padding: 8px 10px;
}
</style>
  